export default __webpack_public_path__ + "static/media/picture.6d2f899c.svg";